import {api} from '../../../system/api';

export default {
    getChildren: (params) => api.get('locations/' + params + '/children'),
};
